import * as Sentry from '@sentry/browser';

const initSentry = () => {
  const dsn = window.gon?.sentry_dsn || 'https://2dcadba2955a6a16c24a1a99f338d373@o4509640983511040.ingest.us.sentry.io/4509640993734656';
  const environment = window.gon?.rails_env || (process.env.NODE_ENV === 'production' ? 'production' : 'development');

  if (!dsn) {
    return;
  }

  const isUserLoggedIn = Boolean(window.gon?.current_user);
  const integrations = [];

  // Only inject and display the feedback widget if the user is authenticated
  if (isUserLoggedIn) {
    integrations.push(
      Sentry.feedbackSyncIntegration({
        colorScheme: 'system',
        autoInject: true,
        showBranding: false,
        useSentryUser: {
          email: 'email',
          name: 'name',
        },
        enableScreenshot: true,
        triggerLabel: 'Feedback',
        formTitle: 'Share your feedback',
        submitButtonLabel: 'Send Feedback',
        messagePlaceholder: 'What went well? What could we improve or fix?',
        successMessageText: 'Thank you for helping us improve Yula!',
      })
    );
  }

  Sentry.init({
    dsn,
    environment,
    debug: environment === 'development',
    integrations,
  });

  if (isUserLoggedIn) {
    Sentry.setUser({
      id: String(window.gon.current_user.id),
      email: window.gon.current_user.email,
      username: window.gon.current_user.username,
      name: window.gon.current_user.name || window.gon.current_user.username,
    });
  }
};

export default initSentry;
